import { httpClient , setResponseType, removeResponseType } from '@/app/shared/services';
import { apiConstants } from '../config';

const URL = apiConstants.parking;

const SERVICE_PARKING_BASE = apiConstants.parkingServiceBase;
const SERVICE_BASE = apiConstants.service;
const SPOT_TYPES_URL = apiConstants.spotsType;

const PARKINGS_PLAN_URL = apiConstants.parkingPlan;
const parkingImage = apiConstants.parkingImages;


const fetchAllParkings = ({page = null, filtro = ''}) => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${URL}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${URL}?${filter}`).then(res => res.data)
  }
};



const fetchAllParkingsSearch = ({page = null, filtro = ''}) => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.post(`${URL}/search?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.post(`${URL}/search?${filter}`).then(res => res.data)
  }
};


const fetchOneParking = (id, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  return httpClient.get(`${URL}/${id}?${filter}`).then(res => res.data);
};


const fetchOneParkingImage = (id, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  return httpClient.get(`${parkingImage}/${id}?${filter}`).then(res => res.data);
};


const downloadExcel = (filename) => {
  setResponseType('blob');
  return httpClient.post(`${URL}/to-excel`, {name: filename}).then(res => {
    setResponseType('json');
    // removeResponseType();
    return res
  });
};

const resetResponseType = () => {
  setResponseType('json');
};


// getServices
const fetchServices = () => {
  return httpClient.get(`${SERVICE_BASE}`).then(res => res.data);
};

const fetchAllParkingServices = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  if (page != null) {
    return httpClient.get(`${SERVICE_PARKING_BASE}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${SERVICE_PARKING_BASE}?${filter}`).then(res => res.data)
  }
};


const fetchOneParkingServices = (id) => {
  return httpClient.get(`${SERVICE_PARKING_BASE}/${id}`).then(res => res.data);
};


// spots

const getSpotTypes = () => {
  return httpClient.get(`${SPOT_TYPES_URL}`).then(res => res.data);
}

// images

// plans

const fetchAllParkingPlans = (page = null, filtro = '') => {
  let filter = filtro.length > 0 ? filtro : "";

  // Filtrar por parkings_id

  if (page != null) {
    return httpClient.get(`${PARKINGS_PLAN_URL}?page=${page}${filter}`).then(res => res.data)
  }
  else {
    return httpClient.get(`${PARKINGS_PLAN_URL}?${filter}`).then(res => res.data)
  }
};

const fetchOneParkingPlan = (id) => {
  return httpClient.get(`${PARKINGS_PLAN_URL}/${id}`).then(res => res.data);
};





export {

  downloadExcel,
  resetResponseType,

  fetchAllParkings,
  fetchAllParkingsSearch,
  fetchOneParking,
  fetchServices,
  fetchAllParkingServices,
  fetchOneParkingServices,

  getSpotTypes, // TODO: api client



  fetchAllParkingPlans,
  fetchOneParkingPlan,
  fetchOneParkingImage


};
